import React, { FunctionComponent } from 'react';
import { faCoins } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconProjectBudget: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faCoins} />;

export { BrassIconProjectBudget };
